import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TaiwanDatePipe } from './taiwan-date.pipe';
import { SafeHtmlPipe } from './safe-html.pipe';
import { SexPipe } from './sex.pipe';
import { KeyValuePipe } from './key-value.pipe';
import { SecondsPipe } from './seconds.pipe';
import { MaskPipe } from 'src/app/shared/pipes/mask.pipe';


@NgModule({
  declarations: [
    TaiwanDatePipe,
    SafeHtmlPipe,
    SexPipe,
    KeyValuePipe,
    SecondsPipe,
    MaskPipe
  ],
  exports: [
    TaiwanDatePipe,
    SafeHtmlPipe,
    SexPipe,
    KeyValuePipe,
    SecondsPipe,
    MaskPipe
  ],
  imports: [
    CommonModule
  ]
})
export class PipesModule { }
